import { Box } from "@mui/material";
import { Route, Routes } from "react-router-dom";
import RfidCard from "../component/rfidCard/RfidCardTable";
const RfidCardPage = () => {
  return (
    <Box>
      <Routes>
        <Route path="/" element={<RfidCard />} />
      </Routes>
    </Box>
  );
};

export default RfidCardPage;
